export const emojiTuBaiBai = {
    label: '兔白白',
    height: 90,
    width: 90,
    path:"/upload/facetime/tubaibai/",
    range:[[20210801,20210809]]
    // items: [
    //     {
    //         'not': 20210801,
    //         'id': 20210801,
    //         'image': '/upload/facetime/tubaibai/20210801.gif',
    //         'title': '爱你',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210801)',
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210802,
    //         'id': 20210802,
    //         'image': '/upload/facetime/tubaibai/20210802.gif',
    //         'title': '爱心发射',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210802)',
    //       //  'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210803,
    //         'id': 20210803,
    //         'image': '/upload/facetime/tubaibai/20210803.gif',
    //         'title': '安慰',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210803)',
    //       //  'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210804,
    //         'id': 20210804,
    //         'image': '/upload/facetime/tubaibai/20210804.gif',
    //         'title': '哈哈哈哈',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210804)',
    //        // 'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210805,
    //         'id': 20210805,
    //         'image': '/upload/facetime/tubaibai/20210805.gif',
    //         'title': '好吃',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210805)',
    //       //  'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210806,
    //         'id': 20210806,
    //         'image': '/upload/facetime/tubaibai/20210806.gif',
    //         'title': '哭泣',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210806)',
    //        // 'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210807,
    //         'id': 20210807,
    //         'image': '/upload/facetime/tubaibai/20210807.gif',
    //         'title': '赖床',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210807)',
    //        // 'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210808,
    //         'id': 20210808,
    //         'image': '/upload/facetime/tubaibai/20210808.gif',
    //         'title': '突然出现',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210808)',
    //        // 'HostLink': host,
    //         'GroupID': 202108
    //     },
    //     {
    //         'not': 20210809,
    //         'id': 20210809,
    //         'image': '/upload/facetime/tubaibai/20210809.gif',
    //         'title': '心碎',
    //         'TypeAvailable': 1,
    //         'IsShow': 1,
    //         'AlternativeName': '(:20210809)',
    //        // 'HostLink': host,
    //         'GroupID': 202108
    //     },
    // ]
}
